import * as Blockly from 'blockly/core';
import 'blockly/python';
//import {getAllowedOutputs} from "./strata_compatibility_checks";
import createCustomThresholdFields from "../strata/strata_custom_threshold_fields";

Blockly.Blocks['globe_indicator'] = {
    init: function() {
      this.appendDummyInput()
          .setAlign(Blockly.ALIGN_LEFT)
          .appendField("Indicator   ")
          .appendField(new Blockly.FieldDropdown([
            ["Sentinel-2 vegetation index change", "ndvi_sentinel2"],
            ["Landsat-8 vegetation index change", "ndvi_landsat"],
            //["Elevation", "elevation"]
            // ["Slope", "slope"],
            // ["Exposed Forest", "exposed_forest"],
            // ["Max wind speed", "max_wind"] ,
            // ["Soil", "soil"],
            // ["historic deforestation", "historic_loss"]
          ]), "indicator_selection");

      createCustomThresholdFields(this);

     
      this.setPreviousStatement(true, 'globe_indicator');
      this.setNextStatement(true);
      this.setStyle('comparison');
      this.setTooltip("");
      this.setHelpUrl("");
    }
  }
